/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { User } from  '../../../account/root/public_api';
import { Observable } from 'rxjs';
import { Title, UserSignUp } from  '../../../profile/root/public_api';

export abstract class UserProfileAdapter {
  abstract update(username: string, user: User): Observable<unknown>;

  abstract register(user: UserSignUp): Observable<User>;

  abstract registerGuest(guid: string, password: string): Observable<User>;

  abstract requestForgotPasswordEmail(
    userEmailAddress: string
  ): Observable<unknown>;

  abstract resetPassword(
    token: string,
    newPassword: string
  ): Observable<unknown>;

  abstract updateEmail(
    userId: string,
    currentPassword: string,
    newUserId: string
  ): Observable<unknown>;

  abstract updatePassword(
    userId: string,
    oldPassword: string,
    newPassword: string
  ): Observable<unknown>;

  abstract close(userId: string): Observable<unknown>;

  abstract loadTitles(): Observable<Title[]>;
}
